<template>
  <div
    v-if="type == 'line'"
    class="progress-line-wrap"
    :style="{ background: backColor }"
  >
    <div
      class="progress-line"
      :style="{ width: value + '%', background: foreColor }"
    ></div>
  </div>
  <svg
    v-else-if="type == 'circle' || type == 'pie' || type == 'circle-array'"
    viewBox="0 0 230 230"
  >
    <circle
      :cx="circleSize"
      :cy="circleSize"
      :r="radius"
      fill="none"
      :stroke="backColor"
      :stroke-width="strokeWidth"
    />
    <template v-if="type == 'circle-array' || type == 'pie-array'">
      <circle
        v-for="(item, index) in circleArray"
        :key="index"
        class="circle-progress"
        :cx="circleSize"
        :cy="circleSize"
        :r="radius"
        fill="transparent"
        :stroke="item.color"
        :stroke-width="strokeWidth"
        :stroke-dashoffset="item.dashoffset"
        :style="{ strokeDasharray: item.dasharray }"
        @mouseover="onMouseOver(item)"
      />
    </template>
    <circle
      v-else
      class="circle-progress"
      :cx="circleSize"
      :cy="circleSize"
      :r="radius"
      :fill="type == 'circle' ? 'none' : backColor"
      :stroke="foreColor"
      :stroke-width="strokeWidth"
      :stroke-dashoffset="dashoffset"
      :stroke-linecap="type == 'circle' ? 'round' : ''"
      :style="{ strokeDasharray: dasharray }"
    />
  </svg>
</template>
<script>
export default {
  name: "ProgressBar",
  props: {
    type: {
      type: String,
      default: "circle",
    },
    value: {},
    backColor: {
      type: String,
      default: "#f7f7f7",
    },
    foreColor: {
      type: String,
      default: "#13cc59",
    },
    spacing: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      circleSize: 115,
      radius: 107,
      dasharray: "",
      strokeWidth: 16,
      circleArray: [],
    };
  },
  computed: {
    perimeter() {
      return Math.PI * this.radius * 2;
    },
    dashoffset() {
      return this.perimeter / 4;
    },
  },
  created() {
    if (this.type == "circle") {
      this.initCircle();
    } else if (this.type == "pie") {
      this.initPie();
    } else if (this.type == "circle-array" || this.type == "pie-array") {
      this.initCircleArray();
    }
  },
  methods: {
    initCircle() {
      let p = (this.perimeter * this.value) / 100;
      this.dasharray = p + " " + (this.perimeter - p);
    },
    initPie() {
      this.radius = this.circleSize / 2;
      this.strokeWidth = this.circleSize;
      let p = (this.perimeter * this.value) / 100;
      this.dasharray = p + " " + (this.perimeter - p);
    },
    initCircleArray() {
      if (this.type == "pie-array") {
        this.radius = this.circleSize / 2;
        this.strokeWidth = this.circleSize;
      }
      let circleArray = [];
      let p = this.dashoffset;
      this.value.forEach(val => {
        let size = (this.perimeter * val.value) / 100;
        let dashoffset = p;
        let dasharray = size + " " + (this.perimeter - size);
        circleArray.push({ dashoffset, dasharray, color: val.color });
        p -= size;
      });
      this.circleArray = circleArray;
    },
    onMouseOver(item) {
      console.log(item);
    },
  },
};
</script>
<style lang="scss" scoped>
.progress-line-wrap {
  height: 8px;
  border-radius: 4px;
  position: relative;
}
.progress-line {
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 4px;
}
.circle-progress {
  transition: stroke-dasharray 2s;
}
</style>
